import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/Event.css";
import apiUrl from "../config";

function EventPage() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        axios
            .get(`${apiUrl}/api/events`)
            .then((response) => setEvents(response.data))
            .catch((error) => console.error("Error fetching events:", error));
    }, []);

    return (
        <div className="event-page">
            {/* Video Banner */}
            <div className="event-section">
                <video className="event-video" autoPlay loop muted playsInline>
                    <source src="/videos/sol3.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div className="event-overlay">
                    <h1 className="event-heading">Discover Exclusive Events</h1>
                    <h2 className="event-subheading">at Sol Cafe Lounge</h2>
                </div>
            </div>

            <div className="events-section">
                <h2 className="event-title-container">Upcoming Events</h2>
                <div className="events-grid">
                    {events.map((event, index) => (
                        <div key={index} className="event-card">
                            <img
                                src={`${apiUrl}${event.image}`}
                                alt={event.title}
                                className="event-image"
                            />
                            <div className="event-details">
                                <h3 className="event-title">{event.title}</h3>
                                <p className="event-date">Date: {event.date}</p>
                                <p className="event-time">Time: {event.time}</p>
                            </div>
                            <a href="/reserve" className="event-button">
                                Book Now
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default EventPage;
